// extracted by mini-css-extract-plugin
export default {"body":"Equipe_body__mP9JZ","majsite":"Equipe_majsite__OvFJl"};